module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAA8klEQVR4Ae3UIQyCQBTGcTc2AsVEM1LNdJPJGbBoD/ZCLxYz2WKxOGa2k61ETSSLwc15fuFV3HfAay/8G95+23nfyDlHN7881uhEtvQ52xeyQ44sN4hBDGIQg0gGoTOIQfDjEGVo1dLZA3L8c06GwlaIYHLklMupq8GHB0VEQf9H5IquCogSBTREMGN0GxBRocj71Qhmgu4DIGoUd36+gpmiZw9Eg5LeOyKYGXp3QLxQyu8Ih9mgrwfigxZay+qzMVu1iRdMQSD28r0qJEAlvxVKEMFEqOK3QgkimBjV/FYoQQSToIbdCjWIYFJiKxQgSv0AK9UOlw2vMQwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_down.png
// module id = 1659
// module chunks = 1